<template>
  <!-- ホルター心電図解析結果承認 -->
  <div id="HolterAnalysisApproval">
    <div id="container">
      <holterNavi v-bind:pageid='"HolterAnalysisApproval"'></holterNavi>
      <div class="labelTitle lable">ホルター心電図解析 結果承認</div>
      <!--検索条件 -->
      <div class="condition-area">
        <table class="conditionTable">
          <tr>
            <th>受付番号</th>
            <td><input type="text" v-model="searchConditions.receiptNumber" maxlength="20"/></td>
            <th>種別</th>
            <td><select v-model="searchConditions.kind">
              <option></option>
                <option value="401">ホルター心電図配送ｻｰﾋﾞｽ</option>
                <!-- しばらく使わない為非表示7/6 <option value="402">ホルター心電図解析ｻｰﾋﾞｽ</option> -->
              </select></td>
            <th>デモ</th>
            <td><select v-model="searchConditions.demo">
              <option></option>
              <option value="false">含まない</option>
              <option value="true">デモのみ</option>
              </select></td>
            <th>解析方法</th>
            <td><select v-model="searchConditions.analysisMethod">
                <option v-for="method in analysisMethodList" :value="method.value" :key="method.value">{{ method.label1 }}</option>
              </select></td>
          </tr>
          <tr>
            <th>解析オプション</th>
            <td><select v-model="searchConditions.analysisOption" name="解析オプション" >
              <option v-for="analysisOption in analysisOptionList" :value="analysisOption.value" :key="analysisOption.value">{{ analysisOption.label1 }}</option>
              </select>
            </td>      
            <th>依頼元</th>
            <td><input type="text" v-model="searchConditions.client" maxlength="256"/></td>
            <th>医療機関</th>
            <td><input type="text" v-model="searchConditions.hospital" maxlength="256"/></td>
            <th>患者名</th>
            <td><input type="text" v-model="searchConditions.patientName"/></td>
          </tr>
          <tr>
            <th>解析担当</th>
            <td><select v-model="searchConditions.Analyst">
                <option></option>
                <option value="1">社内</option>
                <option value="2">委託</option>
              </select></td>
            <th>解析実施者</th>
            <td><input type="text" v-model="searchConditions.analysisStaffName" maxlength="100"/></td>
            <th>状態</th>
            <td><select v-model="searchConditions.status">
                <option></option>
                <option value="1">承認依頼中</option>
                <option value="2">承認済み</option>
                <option value="3">ファイル差替中</option>
              </select></td>
            <th>判定有無</th>
            <td><select v-model="searchConditions.holterJudgmentFlg">
                <option />
                <option value="1">無</option>
                <option value="2">有</option>
              </select></td>
          </tr>
          <tr>
            <th>返却希望日</th>
            <td colspan="3"><input type="date" v-model="searchConditions.returnDeadlineStart"/> ～ <input type="date" v-model="searchConditions.returnDeadlineEnd"/></td>
            <th>解析期限</th>
            <td colspan="3"><input type="date" v-model="searchConditions.analysisDeadlineStart"/> ～ <input type="date" v-model="searchConditions.analysisDeadlineEnd"/></td>
          </tr>
        </table>
        <div class="searchButton-area">
          <b-button class="is-primary" @click="doSearch" >検索</b-button>
        </div>
      </div>
      <!-- 検索結果 -->
      <div class="result-area" v-if="hasResult" >
        <span class="result-count">件数：{{data.length}}件</span>
        <b-table
          id="holterAnalysisResultTable"
          :data="data"
          :paginated="isPaginated"
          per-page="100"
          pagination-position="both"
          default-sort="analysisDeadline"
          default-sort-direction="asc"
          aria-next-label="Next page"
          aria-previous-label="Previous page"
          aria-page-label="Page"
          aria-current-label="Current page"
        >
          <template slot-scope="props">
            <b-table-column field="receiptNumber" label="受付番号" width="100" sortable centered>
              <router-link :to="{name:'HolterAnalysisApprovalDetail', params:{item:props.row, searchConditions:searchConditions}}"><a>{{props.row.receiptNumber}}</a></router-link>
            </b-table-column>
            <b-table-column field="analysisDeadline" label="解析期限" width="120" sortable centered >
              {{props.row.analysisDeadline }}
            </b-table-column>
            <b-table-column field="returnDeadline" label="返却希望日" width="110" sortable centered>
              {{props.row.returnDeadline }}<span v-if="props.row.urgent" class="urgent" />
            </b-table-column>
            <b-table-column field="inspectionKind" label="種別" width="130" sortable>
              {{props.row.inspectionKind}}<span v-if="props.row.demo" class="demo" /><span v-if="props.row.depositMachineFlag" class="depo"/>
            </b-table-column>
            <b-table-column v-if="props.row.inspectionKind=='ホルター心電図配送ｻｰﾋﾞｽ'" field="analysisMethod" label="解析方法" width="150" sortable>
              ホルター心電図
            </b-table-column>
            <b-table-column v-if="props.row.inspectionKind=='ホルター心電図解析ｻｰﾋﾞｽ'" field="analysisMethod" label="解析方法" width="150" sortable>
              {{props.row.analysisMethod | getChoiceFilter(analysisMethodList)}}
            </b-table-column>
            <b-table-column label="解析オプション" field="analysisOption" width="150" sortable >
              {{props.row.analysisOption | getChoiceFilter(analysisOptionList)}}
            </b-table-column>
            <b-table-column field="client" label="依頼元" width="250" sortable>
              {{props.row.client}}
            </b-table-column>
            <b-table-column field="hospital" label="医療機関" width="250" sortable>
              {{props.row.hospital}}
            </b-table-column>
            <b-table-column field="patientName" label="患者名" width="170" sortable>
              {{props.row.patientName}}
            </b-table-column>
            <b-table-column v-if="props.row.cvhri!=-1" field="cvhri" label="CVHRI" width="75" sortable centered>
              {{props.row.cvhri}}
            </b-table-column>
            <b-table-column v-if="props.row.cvhri==-1" field="cvhri" label="CVHRI" width="75" sortable centered>
              算出不可
            </b-table-column>
            <b-table-column v-if="!atLaunchHidden.hiddenFlag && props.row.afKind==0" field="af" label="AF" width="50" sortable centered>
            </b-table-column>
            <b-table-column v-if="props.row.af==1" field="af" label="AF" width="50" sortable centered>
              有
            </b-table-column>
            <b-table-column v-if="props.row.af==2" field="af" label="AF" width="50" sortable centered>
              無
            </b-table-column>
            <b-table-column field="analysisStaffName" width="110" label="解析実施者" sortable>
              {{props.row.analysisStaffName}}
            </b-table-column>
            <b-table-column field="authorizer" width="110" label="承認者" sortable>
              {{props.row.authorizer}}
            </b-table-column>
            <b-table-column field="authorizer" width="110" label="判定有無" sortable>
              {{ props.row.holterJudgmentFlg ? '有' :  '無' }}
            </b-table-column>
            <b-table-column field="status" label="状態" width="80" centered sortable>
              <span :class="getTagClass4PSGApproval(props.row.status)" style="width:100px;">{{props.row.status}}</span>
            </b-table-column>
          </template>
        </b-table>
      </div>
    </div>
  </div>
</template>

<script>
import naviBar from "@/components/mock/philips/holterAnalysis/HolterAnalysisNaviBar";
import {choicesType} from "@/components/mock/base/const.js";
import {atLaunchHidden} from "@/components/mock/base/const.js";

var data = [];
export default {
  name: "HolterAnalysisApproval",
  methods: {
    doSearch: function() {
      var isSearchParam = false
      var keys = Object.keys(this.searchConditions)
      for(var i=0; i < keys.length; i++){
        if(this.searchConditions[keys[i]]){
          isSearchParam = true
          break;
        }
      }
      if(!isSearchParam){
        // 検索条件が１つも設定されていない場合
        this.showErrorMessage("検索条件が入力されていません。")
        return;
      }
      this.data = []
      this.hasResult = false;
      var excuteApi = this.getHolterAnalysisResultApprovalListPOST;
      var successCallBack = this.getHolterAnalysisResultApprovalListPOSTSuccess;
      var errorCallBack = this.getHolterAnalysisResultApprovalListPOSTError;
      // Web Api Call
      this.apiCall(excuteApi, successCallBack, errorCallBack);
    },
    getHolterAnalysisResultApprovalListPOST: function(client) {
      var obj = JSON.parse(JSON.stringify(this.searchConditions));
      return client.apis.internalHolterAnalysis.getHAnalysisResultApprovalListPOST({
        body:obj
      });
    },
    getHolterAnalysisResultApprovalListPOSTSuccess: function(result) {
      // 検索結果取得
      this.data = result.obj
      this.hasResult = true;
    },
    getHolterAnalysisResultApprovalListPOSTError: function(result) {
      // エラーメッセージ表示
      this.showErrorMessage(result);
    },
    getChoicesList: async function() {
      this.analysisMethodList = this.getChoiceList(this.choicesType.holterMethod, false);
      this.analysisOptionList = this.getChoiceList(this.choicesType.holterAnalysisOp, false);
      this.analysisMethodList.unshift({})
      this.analysisOptionList.unshift({})
    },
      // 当日日付を計算
    getDate(){
      return this.yyyy_hyp_MM_hyp_dd(new Date());
    },
  },
  data() {
    var takeOverSearchParams = this.$route.params["searchConditions"];
    var defaultDate = this.getDate();
    return {
      searchConditions:{
        receiptNumber:"",
        kind:"",
        demo:"",
        analysisMethod:"",
        analysisOptionList:"",
        client:"",
        hospital:"",
        patientName:"",
        Analyst: "",
        analysisStaffName: "",
        status: "1",
        analysisDeadlineStart: defaultDate,
        analysisDeadlineEnd: defaultDate,
        returnDeadlineStart:"",
        returnDeadlineEnd:"",
        holterJudgmentFlg: null,
      },
      choicesType:choicesType,
      data: [],
      isPaginated: true,
      analysisMethodList:[],
      analysisOptionList:[],
      takeOverSearchParams,
      hasResult: false,
      atLaunchHidden: atLaunchHidden
    };
  },
  async mounted() {
    // マスタ取得
    await this.getChoicesList();
    if(this.takeOverSearchParams){
      this.searchConditions = this.takeOverSearchParams
      this.doSearch()
    }
  },
  filters: {
    getChoiceFilter(value, analysisMethodList){
      var target = analysisMethodList.find(val => val.value == value)
      if(target){
        return target.label1
      }
      return ""
    }, 
  },
  components: {
    holterNavi: naviBar
  }
};
</script>
<style lang="scss" scoped>
a {
  text-decoration: underline;
}
.tag {
  width: 80px;
}
input {
  width: 200px;
}
</style>



// WEBPACK FOOTER //
// src/components/mock/philips/holterAnalysis/HolterAnalysisApproval.vue